import { useEffect } from 'react';
import Layout from '../../components/feature/Layout';
import ContactHero from './components/ContactHero';
import ContactFormSection from './components/ContactFormSection';
import ContactOfficeSection from './components/ContactOfficeSection';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <ContactHero />
      <ContactFormSection />
      <ContactOfficeSection />
    </Layout>
  );
}
